import { BASE_URL } from './config';
export const logError = async ({ message }) => {
  try {
    await fetch(`${BASE_URL}/Order/writelog`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        message: message ? `Frontend: ${message}` : 'Frontend: Unknown error',
      }),
    });
  } catch (err) {
    console.error('Failed to log error to API', err);
  }
};

